import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconArrowDownLeftComponent } from "./med-icon-arrow-down-left.component";

@NgModule({
  declarations: [
    MedIconArrowDownLeftComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconArrowDownLeftComponent,
  ],
})
export class MedIconArrowDownLeftModule { }
